import React, { ReactElement } from 'react';
import ActionButton from '../action-button/action-button.component';
import FlexContainer from '../flex-container/flex-container.component';
import ParentOpenIcon from '../../icons/parent-open-icon';
import ParentClosedIcon from '../../icons/parent-closed-icon';
import FormatService from '../../services/format-service';
import useStylesActionButtonParent from './action-button-parent.styles';

const ActionButtonParent: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    isOpen,
    isParent,
    isDisabled,
    withOffset,
    withNoMargin,
    onClick,
  } = props;

  const { classes } = useStylesActionButtonParent();

  const offsetClassName: string | undefined = withOffset ? classes.actionButtonParentOffset : undefined;
  const noMarginClassName: string | undefined = withNoMargin ? classes.actionButtonParentNoMargin : undefined;

  return (
    isParent ? (
      <FlexContainer className={classes.actionButtonParent}>
        <ActionButton withNoPadding isDisabled={isDisabled} onClick={onClick}>
          {isOpen ? <ParentOpenIcon /> : <ParentClosedIcon />}
        </ActionButton>
      </FlexContainer>
    ) : (
      <FlexContainer
        className={FormatService.formatClassNames(classes.actionButtonParent, offsetClassName, noMarginClassName)}
      />
    )
  );
});

export default ActionButtonParent;
